import { Component, OnDestroy, OnInit } from '@angular/core';
import { IStatusPanelParams } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import { GridService } from '../service/grid.service';

@Component({
  selector: 'piqet-angular-pagination-bar',
  templateUrl: './pagination-bar.component.html',
  styleUrls: ['./pagination-bar.component.css'],
})
export class PaginationBarComponent implements OnDestroy, OnInit {
  gridName: any;
  params: any;
  currentPage: number = 1;
  totalPages!: number;
  startCount!: number;
  endCount!: number;
  totalCount!: number;
  isFirstPage = true;
  isLastPage!: boolean;
  subscription!: Subscription;
  selectedIndex!: number;
  totalRecord!: number;
  pageSize: any;
  itemsPerPage: any = 3;
  currentPageGroup: any;
  checkPaginationStatus = false;
  start: any;
  end: any;
  numberList = [
    { id: 1, value: '10' },
    { id: 2, value: '25' },
    { id: 3, value: '50' },
    { id: 4, value: '100' },
    // { id: 5, value: 'All' }
  ];
  selectedOption: any = this.numberList[0]; // Default value (Option 2)

  isHidePagination: boolean = false;
  constructor(private gridService: GridService) {}

  agInit(params: IStatusPanelParams): void {
    this.params = params;
    this.pageSize = this.params?.pageSize;
    this.checkPaginationStatus = this.params?.checkPaginationStatus;
    this.gridName = this.params?.gridName;
    this.getGridApi(params);
  }

  ngOnInit() {
    this.params.api.paginationSetPageSize(Number(this.pageSize));
    this.pageSize = this.params.api.paginationGetPageSize();
    this.subscribeToPaginationChanges();
  }

  subscribeToPaginationChanges() {
    this.subscription = this.gridService.gridPaginationChanged$.subscribe(data => {
      if (this.gridName.toLowerCase() == data[3]?.toLowerCase()) {
        this.pageSize = data[2] || Number(this.pageSize);
        this.pageSize > 100
          ? (this.selectedOption = this.numberList[4])
          : this.pageSize == 100
          ? (this.selectedOption = this.numberList[3])
          : this.selectedOption;
        this.params.api.paginationSetPageSize(Number(this.pageSize));
        this.totalRecord = this.params.getTotalRecords();
        this.totalCount = this.params.getTotalFilteredRecords();
        this.selectedIndex = data[1] || 1;
        // this.currentPage = data[1] ||
        // (!this.params.api.paginationGetCurrentPage() ?
        //   this.params.api.paginationGetCurrentPage() + 1 : this.params.api.paginationGetCurrentPage());
        this.totalPages = Math.ceil(
          this.totalCount / (this.pageSize || this.params.api.paginationGetPageSize())
        );
        this.totalPages = !this.totalPages ? 1 : this.totalPages;
        this.isFirstPage = this.currentPage === 1 || this.totalCount == 0;
        this.isLastPage = this.currentPage === this.totalPages || this.totalCount == 0;
        const pageSize = this.pageSize || this.params.api.paginationGetPageSize();
        if (this.totalCount) {
          this.startCount = pageSize * (this.currentPage - 1) + 1;
        } else {
          this.startCount = 0;
        }
        this.totalCount = !!this.totalCount ? this.totalCount : 0;
        this.endCount = Math.min(this.totalCount, pageSize * this.currentPage);
        if (
          this.totalPages == 1 ||
          this.totalPages == 0 ||
          Number.isNaN(this.totalPages) ||
          this.totalPages == undefined ||
          this.totalPages == null
        ) {
          this.isHidePagination = true;
        } else {
          this.isHidePagination = false;
        }
      }
    });
  }
  get range(): string {
    let start = this.currentPage - 1;
    let end = this.currentPage + 1;

    // if (this.totalPages == 0) {
    //   return '0 - 0 of 0';
    // }
    // else if (this.totalPages === 1) {
    //   return '1 - 1 of 1';
    // }

    if (this.currentPage === 1) {
      start = this.currentPage;
      end = this.totalPages < 3 ? this.totalPages : start + 2;
    } else if (this.currentPage === this.totalPages) {
      start = Math.max(this.currentPage - 2, 1);
      end = this.totalPages;
    } else {
      start = Math.max(start, 0);
      end = Math.min(end, this.totalPages);
    }

    const startValue = isNaN(start) ? '0' : String(start);
    const endValue = isNaN(end) ? '0' : String(end);
    const totalPages = isNaN(this.totalPages) ? '0' : String(this.totalPages);

    return `${startValue}-${endValue} of ${totalPages}`;
  }

  getGridApi(params: any): void {
    this.params.getGridApi(params);
  }

  onPageSizeChanged(newValue: any): void {
    this.pageSize = newValue.value;
    this.selectedOption = newValue;
    this.currentPage = 1;
    newValue.value == 'All'
      ? this.params.onPageSizeChanged(this.totalCount)
      : this.params.onPageSizeChanged(newValue.value, 1);
  }

  onPageNumberClicked(currentPage: any) {
    this.currentPage = currentPage;
    this.params.onPageNumberClicked(currentPage, this.gridName, this.pageSize);
  }

  ngOnDestroy(): void {
    this.selectedOption = null;
    this.subscription.unsubscribe();
  }
}
